import { convert } from 'html-to-text';
import str_word_count from 'locutus/php/strings/str_word_count.js';
import strip_tags from 'locutus/php/strings/strip_tags.js';
import trim from 'locutus/php/strings/trim.js';
import get from 'lodash/get.js';

import axios from '@/plugins/axios.js';

class Utilities {
    /**
     * @param string
     * @param limit
     * @param after
     * @return {string}
     */
    static truncate(string, limit, after) {
        if (!string) {
            return '';
        }

        let output = convert(string).split(' ');

        let limitHit;

        if (output.length > limit) {
            limitHit = true;

            output = output.slice(0, limit);

            // Check for punctuation on last word

            output[output.length - 1] = output[output.length - 1].replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, '');
        }

        output = output.join(' ') + (limitHit ? ` ${after}` : '');

        return output;
    }

    /**
     *
     * @param value
     * @return {number|*}
     */
    static async wordCount(value, model = null, modelId = null) {
        if (!value) {
            return 0;
        }

        const withoutHtmlEntities = value.replace(/&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-f]{1,6});/gi, '');

        try {
            const { data } = await axios.post('/api/count-words', {
                text: value,
                model_type: model,
                model_id: modelId,
            });

            return data.data;
        } catch (_e) {
            const words = str_word_count(trim(strip_tags(withoutHtmlEntities)), 1);
            return words.filter(word => word).length;
        }
    }

    static async deprecatedWordCount(value) {
        if (!value) return 0;

        let withoutHtmlEntities = value.replace(/&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-f]{1,6});/gi, '');

        // These additional string replacement calls are included to solve an issue when a
        // table is included within the rich text editor
        // TODO: Consider refactoring to allow the word count to be retrieved from the backend

        withoutHtmlEntities = withoutHtmlEntities.replace(/<\/td>/gi, ',</td>');

        withoutHtmlEntities = withoutHtmlEntities.replace(/0000%;">/gi, '0000%;">,');

        withoutHtmlEntities = withoutHtmlEntities.replace(/<p>/gi, '<p>,');

        withoutHtmlEntities = withoutHtmlEntities.replace(/<\/p>/gi, ',</p>');

        const words = str_word_count(trim(strip_tags(withoutHtmlEntities)), 1);

        return words.filter(word => word).length;
    }

    static initialState(key, def) {
        // eslint-disable-next-line no-underscore-dangle
        return get(window.__INITIAL_STATE__, key, def);
    }

    /**
     *
     * @param first
     * @param last
     * @returns {string}
     */
    static formatUserName({ first, last }) {
        let lastName = last;
        let firstName = first;

        if (lastName.length > 8) {
            const lastNameParts = lastName.split(' ');
            if (lastNameParts.length > 1) {
                lastName = `${lastNameParts[0].charAt(0)}. ${lastNameParts[1].charAt(0)}`;
            } else {
                lastName = `${lastName.charAt(0)}`;
            }
        }

        if (firstName.length > 7) {
            const firstNameParts = firstName.split(' ');
            if (firstNameParts.length > 1) {
                firstName = `${firstNameParts[0].charAt(0)}. ${firstNameParts[1].charAt(0)}`;
            } else {
                firstName = `${firstName.charAt(0)}`;
            }
        }

        return `${lastName}, ${firstName}`;
    }
}

export default Utilities;
